<template>
  <Head title="Iniciar Sesión" />
  <div class="min-h-screen flex items-center justify-center bg-gray-50 p-4 sm:p-6 lg:p-8">
    <div class="w-full max-w-md">
      <!-- Logo -->
      <logo class="block mx-auto w-full mb-2 max-w-xs fill-blue-600 transition-transform hover:scale-105" height="30" />

      <div class="bg-white rounded-xl shadow-lg overflow-hidden">
        <div class="px-6 py-8 sm:px-10 sm:py-10">
          <h2 class="text-2xl font-bold text-gray-900 text-center mb-1">¡Bienvenido de nuevo!</h2>
          <p class="text-center text-sm text-gray-500 mb-6">Ingresa tus credenciales para continuar</p>

          <!-- Botón de Inicio con Google -->
          <div class="mb-5">
            <a
              href="/auth/google/redirect"
              class="w-full flex items-center justify-center gap-3 py-2.5 px-4 bg-white hover:bg-gray-50 text-gray-700 font-semibold text-sm border border-gray-300 rounded-lg shadow-sm hover:shadow transition-all duration-200 transform hover:-translate-y-0.5 active:translate-y-0 group focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-orange-500"
            >
              <svg class="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
              </svg>
              <span class="group-hover:text-gray-900 transition-colors">Continuar con Google</span>
            </a>
          </div>

          <!-- Separador -->
          <div class="relative my-5">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-200" />
            </div>
            <div class="relative flex justify-center text-xs uppercase">
              <span class="bg-white px-3 text-gray-400 font-medium tracking-wider">o con tu correo</span>
            </div>
          </div>

          <form @submit.prevent="login">
            <div class="space-y-4">
              <text-input v-model="form.email" :error="form.errors.email" label="Correo electrónico" type="email" placeholder="ejemplo@correo.com" class="text-sm" autofocus autocomplete="email" autocapitalize="off" />
                 
              <password-input v-model="form.password" :error="form.errors.password" label="Contraseña" class="text-sm" />
            
              <!-- Checkbox recordar -->
              <div class="flex items-center justify-between mt-4">
                <label class="flex items-center select-none cursor-pointer group" for="remember">
                  <input
                    id="remember" v-model="form.remember"
                    class="w-4 h-4 text-orange-600 rounded border-gray-300 focus:ring-orange-500 cursor-pointer"
                    type="checkbox"
                  />
                  <span class="ml-2 text-xs text-gray-600 group-hover:text-gray-800">
                    Mantener sesión
                  </span>
                </label>
                    
                <Link href="/forgot-password" class="text-xs text-orange-600 hover:text-orange-800 font-medium">
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="mt-8">
              <loading-button :loading="form.processing" class="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-2.5 px-4 rounded-lg shadow hover:shadow-md transition-all duration-200 transform hover:-translate-y-0.5 text-sm uppercase tracking-wide flex justify-center items-center" type="submit">
                {{ form.processing ? 'Iniciando sesión...' : 'Iniciar sesión' }}
              </loading-button>
            </div>

            <div class="mt-6 text-center">
              <Link href="/register" class="text-xs text-gray-600 hover:text-orange-600 font-medium transition-colors">
                ¿No tienes cuenta? Regístrate
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import PasswordInput from '@/Shared/PasswordInput'

export default {
  name: 'Login',
  components: { Head, Link, LoadingButton, Logo, TextInput, PasswordInput },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login', {
        onSuccess: () => {},
      })
    },
  },
}
</script>
